module.exports = __webpack_public_path__ + "img/homeBg.b5a0b03e.jpg";